import Image from "next/image";

import clsx from "clsx";

import cartWhite from "@/public/shop/shopping-cart.svg";
import cartBlack from "@/public/shop/shopping-cart-black.svg";

export default function OpenCart({
  type,
  className,
  quantity,
}: {
  type: "light" | "transparent";
  className?: string;
  quantity?: number;
}) {
  return (
    <div className="group h-full p-[2rem] hover:bg-white transition-colors relative flex items-center justify-center">
      <Image
        src={type === "transparent" ? cartWhite : cartBlack}
        alt="Warenkorb"
        className={clsx(
          "w-[3rem] h-[3rem] min-w-[3rem] min-h-[3rem]",
          type === "transparent" && "group-hover:invert transition-all",
          className,
        )}
      />

      {quantity ? (
        <div className="absolute right-[2rem] top-[2rem] -mr-2 -mt-2 h-8 min-h-8 min-w-8 rounded-full px-2 bg-[#1E3739]/80 text-[1.25rem] font-medium text-white border border-white">
          {quantity}
        </div>
      ) : null}
    </div>
  );
}
